import { useState } from 'react';
import { UserTradingSystemCredentials } from '@monorepo/types';
import { useQuery } from '@tanstack/react-query';
import { useStore } from '../../../helpers/use-store';
import { QUERY_CONFIG, QUERY_KEYS } from '../constants';
import { UseNovaTraderLoginParams, UseNovaTraderLoginReturn } from '../types';
import { fetchTradingCredentials } from '../utils';

export const useNovaTraderLogin = ({
  userId,
  tradingSystem,
  accountId,
  contest,
}: UseNovaTraderLoginParams): UseNovaTraderLoginReturn => {
  const {
    dataStore: { userStore, contestAccountStore, accountStore },
  } = useStore();
  const [showPassword, setShowPassword] = useState(false);

  // React Query to fetch trading system credentials
  const {
    data: tsUser,
    isLoading,
    error,
  } = useQuery({
    queryKey: [
      QUERY_KEYS.TRADING_SYSTEM_CREDENTIALS,
      userId,
      tradingSystem,
      accountId,
      contest,
    ],
    queryFn: (): Promise<UserTradingSystemCredentials | null> =>
      fetchTradingCredentials({
        userId,
        tradingSystem,
        accountId,
        contest,
        contestAccountStore,
        accountStore,
        userStore,
      }),
    retry: QUERY_CONFIG.RETRY_COUNT,
    staleTime: QUERY_CONFIG.STALE_TIME,
  });

  const handleCopy = async (text: string): Promise<void> => {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  const togglePasswordVisibility = (): void => {
    setShowPassword(!showPassword);
  };

  return {
    tsUser,
    isLoading,
    error,
    showPassword,
    handleCopy,
    togglePasswordVisibility,
  };
};
